export default {
  buttons: {
    apply: "Bruk",
    cancel: "AVBRYT",
    dismiss: "Stengt",
    minimize: "Minimere",
    unminimize: "Maximere",
    add_waypoint: "legg til bestemmelsessted"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mil"
    }
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Søk",
    placeholder: "Oppgi sted",
    enter_location: "Oppgi sted",
    recent_searches: "Siste søk",
    suggestions: "Forslag",
    help: {
      inactive: "Søk"
    }
  },
  filters: {
    title: "Filtre",
    more: "Flere valg",
    less: "Færre valg",
    group: {
      more: "Mere",
      less: "Mindre"
    },
    amenities: {
      title: "Tjenester og Fasiliteter"
    },
    fuels: {
      title: "Drivstoff"
    }
  },
  directions: {
    title: "Ruteplanlegger",
    help: {
      add_waypoint: "Legg til stopp",
      reverse: "Bytt startpunkt og destinasjon",
      sort_waypoint: "Dra for å endre",
      remove: "Ta bort stopp"
    },
    placeholder: {
      origin: "Velg startpunkt",
      destination: "Oppgi sted",
      waypoint: "Oppgi sted"
    },
    route: {
      title: "Alternativ Rute",
      title_avoid: "Unngå",
      avoid_tolls: "Unngå bompenger",
      avoid_highways: "Unngå motorvei",
      avoid_ferries: "Unngå ferger",
      title_corridor: "Avstand fra rute til Shell stasjon"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# uke} other {# uker}}
{days, plural, =0 {} =1 {# dag} other {# dager}}
{hours, plural, =0 {} =1 {# time} other {# timer}}
{minutes, plural, =0 {} =1 {# minutter} other {# minutter}}\
`,
    button: "Søk",
    error: "En feil oppsto. Vær så snill, prøv på nytt"
  },
  action_panel: {
    back_to_results: "Tilbake til søkeresultatet"
  },
  locations: {
    title: "lokasjon",
    closed_temporarily: "Midlertidig stengt",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} fra {place}",
    description: "{visible, select, true {Gjem} false {Vis} }"
  },
  open_now: {
    open_24_hours: "Døgnåpent"
  },
  info_window: {
    back_to_results: "Tilbake til søkeresultatet",
    title: "Stasjonsdetaljer",
    location_id: "Stasjonsnummer",
    website: "Hjemmeside",
    services: "Tjenester og Fasiliteter",
    nearby: "I nærheten",
    directions: "Legg til i ruteplanleggeren",
    opening_hours: {
      title: "Åpningstid",
      mon: "Man.",
      tue: "Tirs.",
      wed: "Ons.",
      thu: "Tors.",
      fri: "Fre.",
      sat: "Lør.",
      sun: "Søn.",
      open_twentyfourhours: "Døgnåpent",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Drivstoff og pris tilgjengelig",
      not_available: "Drivstoff tilgjengelig",
      price: "{price, number, fuelPrice}",
      disclaimer: "Pris på pumpe gjelder",
      last_updated_on: "Sist oppdatert",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Ruteplanlegger"
  },
  fuels: {
    autogas_lpg: "Autogas (LPG)",
    fuelsave_midgrade_gasoline: "Shell FuelSave Blyfri 95",
    fuelsave_regular_diesel: "REx Diesel, Renewable Regular Diesel",
    premium_diesel: "Shell V-Power Nitro+ Diesel",
    premium_gasoline: "Shell V-Power Nitro+ Blyfri 98",
    shell_regular_diesel: "Diesel Extra",
    truck_diesel: "Truckdiesel",
    shell_recharge: "Ladestasjon for Elbil"
  },
  amenities: {
    air_and_water: "Luft",
    atm: "Minibank",
    austrian_highway_sticker: "Østerrisk motorveismerke",
    bakery_shop: "Bakeri",
    bottled_gas: "Bytte av propanbeholdere",
    burger: "Hurtigmat",
    cafe: "Kafeteria",
    carwash: "Bilvask",
    clubsmart_card: "Club smart card",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "Kredittkort",
    czech_highway_sticker: "Tjekkisk motorveismerke",
    fleet_card_dkv: "Firmakort - DKV",
    fleet_card_eni: "Firmakort - Eni",
    fleet_card_esso: "Firmakort - Esso",
    fleet_card_general: "Firmakort",
    fleet_card_uta: "Firmakort - UTA",
    fuel_card: "Drivstoffkort",
    full_service: "Bemannet kjørebane",
    guarded_car_park: "Overvåket parkeringsplass",
    hgv_lane: "Lastebilvennlig",
    high_speed_diesel_pump: "Hurtigleverende pumpe",
    hot_food: "Varm Mat",
    hungarian_highway_sticker: "Ungarsk motorveismerke",
    jet: "Manuell bilvask",
    loyalty_cards: "Lojalitestkort",
    manual: "Manuell",
    maut_terminal: "Maut Terminal",
    motorway_service: "Bilverksted",
    navigator_fleet_loyalty_discount: "Lojalitetsrabatter",
    others: "Annet",
    parking_lanes: "Parkeringsplass",
    partner_card: "Partnerkort",
    pay_at_pump: "Betaling ved pumpe",
    rollover_and_jet: "Maskinvask og manuell vask",
    rollover: "Maskinvask",
    sandwich: "Hurtigmat",
    selectshop: "Butikk",
    self_service: "Selvbetjening",
    service_bay: "Serviceområde",
    shop: "Butikk",
    shower: "Dusj",
    slovak_highway_sticker: "Slovakisk motorveismerke",
    snack_food: "Hurtigmat",
    standard_toilet: "Toalett",
    supermarket_fuel_discount: "Drivstoffrabatt",
    toilet: "Toalett",
    truck_parking: "Lastebil parkering",
    truckport: "Kun tunge kjøretøy",
    twenty_four_hour: "Døgnåpen",
    vacuum: "Støvsuger",
    budgens: "Tilhengerutleie"
  },
  settings: {
    title: "Innstillinger",
    tooltip: "Innstillinger",
    traffic: "Trafikk",
    distance_units: {
      title: "Distanse",
      km: "kilometer",
      miles: "UK miles"
    },
    language: {
      title: "Språk"
    }
  }
}
